<template>
  <v-overlay color="primary" opacity="1" style="z-index: 1000">
    <v-card color="white" elevation="30" light width="550">
      <v-card-text class="pa-5">
        <stack-assist-logo />
      </v-card-text>
      <v-card-text v-if="failed && message">
        <v-alert type="error">
          {{ message }}
        </v-alert>
      </v-card-text>
      <v-card-title v-if="loading">
        <loading text="Checking verification link ..." />
      </v-card-title>
      <v-card-title v-else> Your email address is not verified </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="handleForm">
          <v-card-actions class="mt-5 pa-0">
            <v-btn type="submit" color="primary">
              <v-icon class="mr-2"> mdi-email </v-icon>
              Re-send verification link
            </v-btn>
            <v-btn :to="{ name: 'logout' }" text class="ml-5"> Logout </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
import api from '@/api'
import { showSnackbar } from '@/actions'
import Loading from '@/components/Loading.vue'
import { useUserStore } from '@/stores/UserStore'
import StackAssistLogo from '../../components/StackAssistLogo.vue'

export default {
  components: { StackAssistLogo, Loading },
  data() {
    return {
      loading: false,
      failed: false,
      message: '',
    }
  },

  setup() {
    const UserStore = useUserStore()

    return {
      UserStore,
    }
  },

  mounted() {
    if (!this.UserStore.isLoggedIn()) {
      showSnackbar(
        'Please log in before verifying your email address.',
        null,
        'success'
      )
      return this.$router.push({ name: 'login' })
    }

    if (this.UserStore.hasEmailVerified()) {
      showSnackbar('Email address already verified', null, 'success')
      return this.$router.push({ name: 'homepage' })
    }

    let url = this.$route.query.url
    if (url) {
      this.loading = true
      api
        .get(url, { _auth: true })
        .then((response) => {
          showSnackbar('Email address verified', null, 'success')
          this.UserStore.fill(response.data)
          this.$router.push({ name: 'homepage' })
          this.loading = false
        })
        .catch((err) => {
          showSnackbar('Verification failed', null, 'error')
          this.loading = false
          this.failed = true
          this.message = err.response.data.message
        })
    }
  },

  methods: {
    handleForm() {
      api
        .post('email/verification-notification', {}, { _auth: true })
        .then(() => {
          showSnackbar(
            'Email sent',
            'An email has been sent with instructions how to verify your email address.',
            'success'
          )
          this.failed = false
        })
        .catch(() => {
          showSnackbar('Verification failed', null, 'error')
          this.failed = true
        })
    },
  },
}
</script>

<style scoped></style>
